export default __webpack_public_path__ + "static/media/24.3da4c1c1.jpg";